import React, { useRef, useEffect } from 'react';
import { loadHistory } from '../utils/useGameHistory';

export default function TeamGameWrapper({ 
  children, 
  isTeamMode, 
  onWrongAnswer, 
  onCorrectAnswer 
}) {
  const gameRef = useRef(null);
  const lastHistoryRef = useRef(null);

  useEffect(() => {
    if (!isTeamMode) return;

    // Monitor localStorage for game history changes
    const checkForHistoryChanges = () => {
      const currentHistory = loadHistory();
      const lastHistory = lastHistoryRef.current;

      if (!lastHistory) {
        // First check, just store the current state
        lastHistoryRef.current = JSON.parse(JSON.stringify(currentHistory));
        return;
      }

      // Check all games for changes
      const gameIds = Object.keys(currentHistory);
      for (const gameId of gameIds) {
        const current = currentHistory[gameId] || { played: 0, correct: 0, wrong: 0 };
        const last = lastHistory[gameId] || { played: 0, correct: 0, wrong: 0 };

        // Check if a new round was played
        if (current.played > last.played) {
          // Determine if it was correct or wrong
          const wasCorrect = current.correct > last.correct;
          
          if (wasCorrect) {
            // Always award 1 point for correct answers in team mode
            onCorrectAnswer?.(1);
          } else {
            // Rotate to next team on wrong answer
            onWrongAnswer?.();
          }
          
          // Update our reference
          lastHistoryRef.current = JSON.parse(JSON.stringify(currentHistory));
          break; // Only process one change at a time
        }
      }
    };

    // Poll for history changes
    const interval = setInterval(checkForHistoryChanges, 100);
    
    // Also listen for storage events from other tabs (though not needed here)
    const handleStorage = (e) => {
      if (e.key === 'biblika_game_history') {
        checkForHistoryChanges();
      }
    };
    window.addEventListener('storage', handleStorage);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorage);
    };
  }, [isTeamMode, onWrongAnswer, onCorrectAnswer]);

  return (
    <div ref={gameRef}>
      {children}
    </div>
  );
}